module.exports = __webpack_public_path__ + "static/media/aragon97.0cafc4c7.jpg";